import * as React from 'react';
import {DefaultButton, Dropdown, PrimaryButton} from '@fluentui/react';
import { Panel } from '@fluentui/react';
import {useContext, useEffect, useState} from "react";
import {Stack} from "@fluentui/react";
import AuthContext from "../../Services/AuthContext";

function AddUserRole(props) {
    const [user] = useContext(AuthContext);
    const [role, setRole] = useState('');
    const [roles, setRoles] = useState([]);

    const _submit = (e) => {
        e.preventDefault();
        const data = {role: role.key};
        fetch(`/api/user/${props.add}/role`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => { props.onSuccess(json); props.dismissPanel(); })
            .catch(err => { console.log(err) })
    }

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign='space-between'>
        <PrimaryButton type='submit' form='AddUserRole'>Dodaj</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);


    useEffect(() => {
        const abortController = new AbortController();
        setRole('');
        if (props.add) {
            async function fetchData() {
                await fetch(`/api/role`, {
                    method: 'GET',
                    signal: abortController.signal,
                    headers: {
                        'Authorization': 'Bearer ' + user.token
                    }
                }).then(res => res.json())
                    .then(data => {
                        setRoles(data.map((item) => {
                            return {key: item.role, text: item.role};
                        }))
                    })
                    .catch(err => {
                        console.log(err)
                    })
            }
            fetchData();
        }
        return () => abortController.abort();
    }, [props.add, user.token])


    return (
        <Panel
            isOpen={props.add}
            onDismiss={props.dismissPanel}
            headerText="Dodaj Role"
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
        >
            <form onSubmit={_submit} id='AddUserRole'>
                <Dropdown
                    label="Rola"
                    selectedKey={role ? role.key : undefined}
                    onChange={(e, item) => setRole(item)}
                    placeholder="Wybierz z listy"
                    options={roles}
                />
            </form>
        </Panel>
    )
}

export default AddUserRole;